import React from "react";
import ContactSection from "./ContactSection";

const ContactPage = () => {
    return (
        <div className="py-20 bg-gray-900 min-h-screen">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-4xl font-bold text-center mb-8 text-white">Contact Us</h1>
                <p className="text-lg text-gray-400 text-center mb-12">
                    Have questions or need support? We're here to help! Reach out to us through any of the following channels.
                </p>
                
                <ContactSection />
            </div>
        </div>
    );
};

export default ContactPage;

